export const getProxiedMapServerUrl = (url: string) => {
  if (process.env.NODE_ENV === 'development' && url.includes('mapserver.landler.io')) {
    return url.replace('https://mapserver.landler.io', `${window.location.origin}/local-map-tiles`);
  }
  return url;
};

export type MapBoxRequestMethod = 'GET' | 'POST';

// Marker appended to tile URLs so a per-layer HTTP method survives mapbox's {bbox-epsg-3857} substitution
const REQUEST_METHOD_PARAM = '__requestMethod';
const POST_REQUEST_PATTERN = new RegExp(`[?&]${REQUEST_METHOD_PARAM}=POST$`);

/**
 * Appends a request method marker to the URL, so that MapBox changes the HTTP request type accordingly.
 */
export const withRequestMethod = (url: string, method?: MapBoxRequestMethod) => {
  if (!url || method !== 'POST') {
    return url;
  }
  const urlSeparator = url.includes('?') ? '&' : '?';
  return `${url}${urlSeparator}${REQUEST_METHOD_PARAM}=POST`;
};

/**
 * Decodes the request method marker and, for POST requests, moves the query params into a url-encoded body.
 */
export const extractRequestParams = (url: string): { url: string; method: MapBoxRequestMethod; body?: string } => {
  if (!POST_REQUEST_PATTERN.test(url)) {
    return { url, method: 'GET' };
  }

  const cleanUrl = url.replace(POST_REQUEST_PATTERN, '');
  const [baseUrl = cleanUrl, queryString] = cleanUrl.split('?');

  if (!queryString) {
    return { url: baseUrl, method: 'POST' };
  }

  return { url: baseUrl, method: 'POST', body: queryString };
};
